import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: 'craig-header',
    standalone: true,
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.less'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class HeaderComponent {}
